import { useGoalTemplateByGoalIdQuery } from 'shared/hooks/queries/use-goal-template-by-goal-id-query';
import { ID } from 'shared/types/id';

export const useGoalTemplateByGoalId = (goalId?: ID) => {
  const { data: template } = useGoalTemplateByGoalIdQuery(goalId);

  return template;
};
